module.exports = __webpack_public_path__ + "img/card_result@3x.ddd60540.png";